import React, { useEffect } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import { connect } from 'react-redux'
import moment from 'moment'

import TitleBar from '../../../titleBar/title_bar';
import AgGridTable from '../../../common/agGridTable';
import LoadingPlaceholder from '../../../placeholderComponent/loadingPlaceholder'

import BillActionButton from './billActionButton';
import PaymentActionButton from './paymentActionButton';

import { deleteBill, getVendorBills } from '../../../../redux/actions/billActions';
import { getVendorPurchaseOrder } from '../../../../redux/actions/purchaseOrderActions';
import billInvoicePdfActionButton from './billInvoicePdfActionButton';

function BillsTable(props) {

    const { billsData, billsLoading, getVendorBills, deleteBill, deleteBillIsLoading, getVendorPurchaseOrder } = props;

    useEffect(() => {
        let vendorCode = localStorage.getItem("vendorCode")
        getVendorBills(vendorCode)
        console.log('>>>>', props)
    }, [getVendorBills]);

    let handleEditmode = (data) => {
        console.log("edit data : ", data)
    }

    if (billsLoading) {
        return (
            <React.Fragment>
                <TitleBar title="Bills" LinkName="add-bill" />
                <LoadingPlaceholder />
            </React.Fragment>
        )

    } else if (billsData && billsData.length === 0) {
        return (
            <React.Fragment>
                <TitleBar title="Bills" LinkName="add-bill" />
                <Segment className="m-2">
                    <center><Header>No Record(s) Found</Header></center>
                </Segment>
            </React.Fragment>
        )
    } else {
        const customerNo = localStorage.getItem('customerNumber')

        let vendorHeader = {}

        if (customerNo != 1158) {
            vendorHeader.vendorName = "Vendor Name"
            vendorHeader.vendorBillNo = "Vendor Bill No."
            vendorHeader.vendorBillDate = "Vendor Bill Date"
        } else {
            vendorHeader.vendorName = "Partner Name"
            vendorHeader.vendorBillNo = "Partner Bill No."
            vendorHeader.vendorBillDate = "Partner Bill Date"
        }

        let columnDefs = [
            { headerName: vendorHeader.vendorName, field: 'vendorName', tooltipField: 'vendorName', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: vendorHeader.vendorBillNo, field: 'vendorBillNo', cellRenderer: 'paymentModalRenderer', tooltipField: 'vendorBillNo', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: vendorHeader.vendorBillDate, field: 'vendorBillDate', tooltipField: 'vendorBillDate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Bill Receipt Date', field: 'billReceiptDate', tooltipField: 'billReceiptDate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Bill Amount', field: 'billAmount', tooltipField: 'billAmount', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Pending Amount', field: 'pendingAmount', tooltipField: 'pendingAmount', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Expected Payment Date', field: 'expectedPaymentDate', tooltipField: 'expectedPaymentDate', enableRowGroup: true, enablePivot: true, filter: true },
            {
                headerName: 'Status', field: 'status', tooltipField: 'status', enableRowGroup: true, enablePivot: true, filter: true, cellStyle: params => {
                    if (params.value === 'Approved') {
                        return { color: 'green' };
                    } else if (params.value === 'Rejected') {
                        return { color: 'red' };
                    } else {
                        return { color: 'grey' };
                    }
                }
            },
            { headerName: 'Bill Invoice PDF', field: 'biPdf', cellRenderer: 'billInvoicePdfRenderer', suppressToolPanel: true },
            { headerName: 'Created On', field: 'createdOn', tooltipField: 'createdOn', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Created By', field: 'createdBy', tooltipField: 'createdBy', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Modified On', field: 'modifiedOn', tooltipField: 'modifiedOn', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Modified By', field: 'modifiedBy', tooltipField: 'modifiedBy', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'View/Delete', field: 'edit', cellRenderer: 'billRenderer', width: 280, suppressToolPanel: true, pinned: 'right' }
        ]

        let frameworkComponents = {
            billRenderer: BillActionButton,
            paymentModalRenderer: PaymentActionButton,
            billInvoicePdfRenderer: billInvoicePdfActionButton
        }

        let rowData = []

        billsData && billsData.forEach((object, index) => {
            let temp = {}
            temp.vendorBillNo = object.billNo
            temp.billReferenceNo = object.billReferenceNo
            temp.vendorBillDate = moment(object.billDate).format('DD-MM-YYYY')
            temp.billReceiptDate = moment(object.billReceiptDate).format('DD-MM-YYYY')
            temp.vendorName = object.vendorName
            temp.billAmount = object.billAmount
            temp.pendingAmount = object.pendingAmount
            temp.expectedPaymentDate = moment(object.expectedPaymentDate).format('DD-MM-YYYY')
            temp.status = object.approvalStatus
            temp.createdOn = object.createdOn
            // temp.createdOn = moment(object.createdOn).format('DD-MM-YYYY') === "Invalid date" ? '' : moment(object.createdOn).format('DD-MM-YYYY')
            temp.createdBy = object.createdByName
            temp.modifiedOn = object.updatedOn
            temp.modifiedBy = object.updatedByName
            temp.deleteBill = deleteBill
            temp.isLoading = deleteBillIsLoading
            temp.getVendorPurchaseOrder = getVendorPurchaseOrder
            //Extra Data for Edit
            temp.vendorCode = object.vendorCode
            temp.billPO = object.bill_po_mapping
            temp.billId = object.billId
            rowData[index] = temp
        })
        return (
            <React.Fragment>
                <AgGridTable
                    columnDefs={columnDefs}
                    rowData={rowData}
                    searchValue={props.searchValue}
                    // onEdit={handleEditmode}
                    titleBarLink="/add-bill"
                    baseURL={props}
                    hiddenNewPopupBtn={true}
                    hiddenImportPopupBtn={true}
                    extraComponents={frameworkComponents}
                    titleBarTitle="Bills"
                    handleSearch={props.handleSearch}
                />
            </React.Fragment>
        )
    }
}


const mapStatetoProps = (state) => ({
    billsData: state.getVendorBillsReducer.bills.data,
    billsLoading: state.getVendorBillsReducer.isLoading,
    deleteBillIsLoading: state.deleteBillReducer.isLoading
})
export default connect(mapStatetoProps, { getVendorBills, deleteBill, getVendorPurchaseOrder })(BillsTable)
// export default connect(mapStatetoProps, { getVendorBills })(BillsTable)